module.exports = __webpack_public_path__ + "static/blog-19-4efdc32cf680310e175feddd2a904327.png";